'use client';

import { ClientOnlyLoader } from '../ClientOnlyLoader';
import { ComponentProps } from 'react';
import { BaseLink } from '@/navigation';

const clientOnlyLinkLoader = () => import('./ClientLink');

type AppLinkProps = ComponentProps<typeof BaseLink>;

export function ClientOnlyLink(props: AppLinkProps) {
  return <ClientOnlyLoader load={clientOnlyLinkLoader} fallback={<BaseLink {...props} />} props={props} />;
}
